<template >
  <v-icon :color="color">
    {{ icon }}
  </v-icon>
</template>


<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    color() {
      return this.value ? "success" : "error";
    },
    icon() {
      return this.value ? "mdi-check-bold" : "mdi-close-thick";
    },
  },
};
</script>
